import React from 'react';
import UploadCatalogoFornecedor from '../UploadCatalogoFornecedor/UploadCatalogoFornecedor';

type Props = { closeAction: Function; closeActionSimple: Function };

const UploadIfood: React.FC<Props> = (props) => <UploadCatalogoFornecedor {...props}
  source={"IFOOD"} title={"Importar catálogo iFood"}
  instructions={"Copie a URL pública da loja no iFood. Também é possível informar o comando cURL do catálogo."}
  placeholder={"URL da loja ou comando cURL"} multiline />;

export default UploadIfood;
